import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	template: `
    <div class="container">
        <div class="jumbotron">
            <h1 class="display-3">{{ title.title }}</h1>
            <p class="lead">{{ title.subtitle }}</p>
            <hr class="my-4">
            <p>Please, press Home button to navigate to the main page!</p>
            <p class="lead">
              <a class="btn btn-info btn-lg" href="#" role="button">Home</a>
            </p>
        </div>
    </div>
    `
})

export class PageNotFoundComponent implements OnInit {
	title = {
		title: 'Page not found',
		subtitle: 'The page you are navigating does not exist or not reachable.'
	};

	constructor(private route: ActivatedRoute) { }

	ngOnInit() {
		const queryParam = this.route.snapshot.queryParams;
		if (queryParam.param === 'notamember') {
			this.title = {
				title: 'Access Not Allowed',
				subtitle: 'You do not have permission to access this page. Please, contact your suppervisor for an access.'
			};
		} else {
			return;
		}
	}
}
